export const ru = {
    account: 'Учётная запись',
    'add-tag-error': 'Не удалось добавить тег',
    address: 'Адрес',
    all: 'Все',
    'all-pages': 'Все страницы',
    appearance: 'Внешний вид',
    'appearance-section': 'Настройте оформление интерфейса для комфортной работы',
    cancel: 'Отменить',
    'created-and-edited': 'Создано и изменено',
    'created-and-edited-column-author': 'Автор',
    'created-and-edited-column-created-at': 'Создано',
    'created-and-edited-column-modified-at': 'Обновлено',
    'created-and-edited-column-name': 'Название страницы',
    'created-and-edited-column-slug': 'Путь',
    'created-and-edited-empty-result': 'По вашему запросу ничего не нашлось',
    'created-and-edited-error': 'Произошла ошибка при загрузке данных',
    'created-and-edited-filter-all': 'Показать всё',
    'created-and-edited-filter-creator': 'Я автор',
    'created-and-edited-filter-editor': 'Я редактор',
    'created-and-edited-filter-error': 'Не удалось выполнить поиск',
    'created-and-edited-hint': 'Страницы, которые вы создали или отредактировали.',
    'created-and-edited-no-data': 'Страницы, которые вы создадите или отредактируете, появятся здесь. \nПока таких страниц нет.',
    'created-and-edited-personal-cluster': 'Перейти на личную страницу',
    delete: 'Удалить',
    'delete-page-without-recover': 'Страница будет удалена без возможности восстановления',
    'delete-perm': 'Удалить навсегда',
    'delete-perm-quest': 'Удалить страницу навсегда?',
    deleted: 'Удалено',
    'deleted-by-me': 'Удалены мной',
    documentation: 'Документация',
    'documentation-create-page': 'Как создать страницу',
    'documentation-dynamic-blocks': 'Динамические блоки',
    'documentation-edit-text': 'Как редактировать текст',
    'documentation-getting-started': 'Начало работы',
    'documentation-go-to': 'Перейти к документации',
    'documentation-markup-reference': 'Справочник разметки',
    'empty-description': 'Не удалось получить настройки. Попробуйте ещё раз.',
    'empty-title': 'Произошла ошибка',
    'favorite-no-data': 'Страницы, которые вы добавите в избранное, появятся здесь. \nПока таких страниц нет.',
    'favorite-pages': 'Избранные страницы',
    'favorite-pages-hint': 'Добавляйте страницы в избранное, чтобы не потерять их. Фильтруйте избранные страницы по тегам.',
    'favorites-add-item': 'Добавить в избранное',
    'favorites-add-tag-error': 'Не удалось добавить тег',
    'favorites-column-author': 'Автор',
    'favorites-column-created-at': 'Создано',
    'favorites-column-modified-at': 'Обновлено',
    'favorites-column-slug': 'Путь',
    'favorites-column-tags': 'Теги',
    'favorites-column-title': 'Название страницы',
    'favorites-create-error': 'Не удалось добавить страницу в избранное',
    'favorites-create-tag-error': 'Не удалось добавить тег',
    'favorites-delete-error': 'Не удалось удалить страницу из избранного',
    'favorites-delete-item': 'Удалить из избранного',
    'favorites-filter-error': 'Не удалось выполнить поиск',
    'favorites-load-error': 'Не удалось загрузить список страниц',
    'favorites-load-tags-error': 'Не удалось загрузить теги',
    'favorites-no-data-for-query': 'По вашему запросу ничего не нашлось',
    'favorites-table-settings-error': 'Не удалось сохранить настройки, некоторые данные могут быть потеряны.',
    'favorites-tags-error': 'Не удалось загрузить тег',
    'favorites-tags-label': 'Теги',
    'favorites-update-error': 'Не удалось обновить избранное',
    'feature-data-ui-web': 'Новый интерфейс',
    'feature-is-processing-description': 'Список страниц отобразится после синхронизации. Попробуйте вернуться через несколько минут.',
    'feature-is-processing-title': 'Переносим данные',
    'feature-wysiwyg-editor': 'Новый редактор по-умолчанию',
    featured: 'Важное в компании',
    'featured-error': 'Не удалось загрузить данные',
    'featured-hint': 'Страницы с полезной информацией о правилах и процедурах компании.',
    features: 'Эксперименты',
    'features-section': 'Поучаствуйте в наших экспериментах',
    feedback: 'Обратная связь',
    'feedback-bug-report': 'Сообщить об ошибке',
    'feedback-suggest-improvement': 'Предложить улучшение',
    'history-of-changes': 'История изменений',
    'interface-theme': 'Тема интерфейса',
    invite: 'Добавить пользователя',
    language: 'Язык интерфейса',
    'language-and-region': 'Язык и регион',
    'language-and-region-section': 'Выберите язык пользовательского интерфейса',
    'language-english': 'English',
    'language-russian': 'Русский',
    locked: 'Хранится до',
    'menu-item-create-page': 'Создать страницу',
    'menu-item-created-and-edited': 'Создано и изменено',
    'menu-item-favorites': 'Избранное',
    'menu-item-featured': 'Важное в компании',
    'menu-item-personal-cluster': 'Моя страница',
    'menu-item-subscriptions': 'Подписки',
    'my-pages': 'Мои страницы',
    notifications: 'Уведомления',
    'open-page': 'Открыть страницу',
    page: 'Страница',
    'page-deleted': 'Страница удалена',
    'page-restored': 'Страница восстановлена',
    'recently-deleted': 'Недавно удаленные',
    recover: 'Восстановить',
    'recovery-tokens-no-data-message': 'Здесь будут храниться удалённые страницы Wiki. У вас пока нет таких страниц.',
    'remove-pages': 'Недавно удаленные',
    search: 'Поиск',
    'search-not-found-description': 'Не результатов по запросу "{{query}}". Попробуйте сформулировать запрос иначе.',
    'search-not-found-title': 'Ничего не найдено',
    'search-placeholder': 'Поиск по страницам Wiki [{{key}}+s]',
    'settings-get-error': 'Не удалось получить настройки',
    'settings-propose-translation': 'Предлагать перевод контента',
    'settings-propose-translation-dont-propose': 'Не предлагать',
    'settings-propose-translation-propose': 'Предлагать',
    'settings-update-error': 'Не удалось сохранить настройки',
    'settings-update-error-description': 'Произошла ошибка. Настройки могут не сохраниться.',
    subscriptions: 'Подписки',
    'subscriptions-column-author': 'Автор',
    'subscriptions-column-created-at': 'Создано',
    'subscriptions-column-modified-at': 'Обновлено',
    'subscriptions-column-name': 'Название раздела/страницы',
    'subscriptions-column-slug': 'Путь',
    'subscriptions-create-error': 'Не удалось добавить подписку',
    'subscriptions-create-success': 'Подписка добавлена',
    'subscriptions-delete-error': 'Не удалось удалить подписку',
    'subscriptions-delete-success': 'Подписка удалена',
    'subscriptions-empty-result': 'По вашему запросу ничего не нашлось',
    'subscriptions-error': 'Не удалось загрузить список страниц',
    'subscriptions-filter-all': 'Показать всё',
    'subscriptions-filter-error': 'Не удалось выполнить поиск',
    'subscriptions-filter-my': 'Мои подписки',
    'subscriptions-filter-other': 'Меня подписали',
    'subscriptions-hint': 'Страницы, на изменения которых вы подписались или вас подписали другие пользователи.',
    'subscriptions-no-data': 'Страницы, на которые вы подпишетесь, появятся здесь. Пока таких страниц нет.',
    'subscriptions-subscribe': 'Подписаться',
    'subscriptions-unsubscribe': 'Отписаться',
    'tabs-search-by-name': 'Поиск по названию',
    'theme-contrast': 'Контрастность',
    'theme-contrast-high': 'Высокая (beta)',
    'theme-contrast-normal': 'Стандартная',
    'theme-dark': 'Тёмная',
    'theme-light': 'Светлая',
    'theme-system': 'Системная'
};
